import {
  VALIDATE_TOKEN,
  VALIDATE_TOKEN_SUCCESS,
  VALIDATE_TOKEN_FAILURE,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const validateTokenReducer = (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_TOKEN:
      return { ...state, loading: true };
    case VALIDATE_TOKEN_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case VALIDATE_TOKEN_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default validateTokenReducer;
